const {
	REACT_APP_WOPI_BASE_URL,
	REACT_APP_OFFICE_WORD_EDIT_URL,
	REACT_APP_OFFICE_WORD_VIEW_URL,

	REACT_APP_OFFICE_EXCEL_EDIT_URL,
	REACT_APP_OFFICE_EXCEL_VIEW_URL,

	REACT_APP_OFFICE_PRESENTATION_EDIT_URL,
	REACT_APP_OFFICE_PRESENTATION_VIEW_URL,

	REACT_APP_OFFICE_WOPITEST_VIEW_URL,
	REACT_APP_OFFICE_WOPITEST_EDIT_URL,

	REACT_APP_OFFICE_WOPITESTX_VIEW_URL,
	REACT_APP_OFFICE_WOPITESTX_EDIT_URL,
} = process.env || {};

export const coreAppURL = REACT_APP_WOPI_BASE_URL || "";
export const isCSPPEnabled = Boolean(REACT_APP_OFFICE_WORD_VIEW_URL);

export const officeWordEditURL = REACT_APP_OFFICE_WORD_EDIT_URL
	? `${REACT_APP_OFFICE_WORD_EDIT_URL}?lang=en`
	: 'https://word-edit.officeapps.live.com/we/wordeditorframe.aspx?lang=en';

export const officeWordViewURL = REACT_APP_OFFICE_WORD_VIEW_URL
	? `${REACT_APP_OFFICE_WORD_VIEW_URL}?lang=en`
	: 'https://word-view.officeapps.live.com/wv/wordviewerframe.aspx?lang=en';

export const officePresentationViewUrl =
	REACT_APP_OFFICE_PRESENTATION_EDIT_URL ||
	'https://powerpoint.officeapps.live.com/p/PowerPointFrame.aspx?PowerPointView=ReadingView';

export const officePresentationEditUrl =
	REACT_APP_OFFICE_PRESENTATION_VIEW_URL ||
	'https://powerpoint.officeapps.live.com/p/PowerPointFrame.aspx?PowerPointView=EditView';

export const officeExcelViewUrl =
	REACT_APP_OFFICE_EXCEL_EDIT_URL || 'https://excel.officeapps.live.com/x/_layouts/xlviewerinternal.aspx?lang=en';
export const officeExcelEditUrl =
	REACT_APP_OFFICE_EXCEL_VIEW_URL || 'https://excel.officeapps.live.com/x/_layouts/xlviewerinternal.aspx?edit=1';

export const wopitestViewURL =
	REACT_APP_OFFICE_WOPITEST_VIEW_URL || 'https://FFC-onenote.officeapps.live.com/hosting/WopiTestFrame.aspx?lang=en';
export const wopitestEditURL =
	REACT_APP_OFFICE_WOPITEST_EDIT_URL || 'https://FFC-onenote.officeapps.live.com/hosting/WopiTestFrame.aspx?lang=en';

export const wopitestxViewURL =
	REACT_APP_OFFICE_WOPITESTX_VIEW_URL || 'https://FFC-onenote.officeapps.live.com/hosting/WopiTestFrame.aspx?lang=en';
export const wopitestxEditURL =
	REACT_APP_OFFICE_WOPITESTX_EDIT_URL || 'https://FFC-onenote.officeapps.live.com/hosting/WopiTestFrame.aspx?lang=en';
